/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-props-no-spreading */
import React, { SelectHTMLAttributes } from 'react';

import Select from 'react-select';
import './styles.css'

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  onChange: any;
  name: string;
  options: Array<{
    value: string;
    label: string;
  }>;
  placeholder: string;
  defaultValue?: any;
  isSearchable?: boolean;
  notDropDown?: boolean;
}

const MultiSelect: React.FC<SelectProps> = (
  {
    label,
    name,
    options,
    placeholder,
    onChange,
    defaultValue,
    isSearchable,
    notDropDown,
  }: SelectProps,
  ...rest
) => {
  const customStyles = {
    control: (base: any) => ({
      ...base,
      height: '55px',
      outline: 0,
      marginTop: '0.8rem',
      borderRadius: '0.5rem',
      padding: '0.5rem',
      background: '#f8f8f8',
      boxShadow: 'none',
      fontFamily: 'Heebo, sans-serif',
      fontSize: '0.9rem',
    }),
    option: (base: any) => ({
      ...base,
      display: notDropDown ? 'none' : 'block',
    }),
  };

  return (
    <div className="inputblock">
      <label htmlFor={name}>{label}</label>

      <Select
        className="select"
        options={options}
        isMulti
        isSearchable={isSearchable}
        defaultValue={defaultValue}
        styles={customStyles}
        placeholder={placeholder}
        onChange={onChange}
        {...rest}
      />
    </div>
  );
};

export default MultiSelect;